import * as z from "zod/v4";
import { aeoDateRangeInput } from "./types";

const modelData_ = z.object({
  model: z.string().describe("AI model name"),
  mentions: z.number().describe("Brand mentions from this model"),
});
export const modelData: z.ZodType<ModelData> = modelData_;
export interface ModelData extends z.infer<typeof modelData_> {}

export const getModelPerformance = {
  name: "getModelPerformance" as const,
  input: aeoDateRangeInput,
  output: z.object({ models: z.array(modelData) }),
};
